<template>
  <div class="m-container">
    <m_header></m_header>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">用户列表查询</div>
          <span class="m-title-s">用户账户注册信息查询</span>
        </div>
<!--        <div class="m-total">-->
          <div class="m-total-item">
            <div style="font-weight: bold;">
              总用户数：{{ total }} 人
            </div>
            <div style="font-size: 12px;color: #ff2020;">未选择查询时间段时，数据均为累积总数</div>
          </div>
          <div class="m-total-time-search">
            查询时间：
            <el-date-picker
              v-model="dateArr"
              @change="onDateChange"
              type="datetimerange"
              :default-time="['00:00:00','23:59:59']"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
            <div style="margin-left: 20px;">
              <el-button type="primary" @click="loadListSearch()" size="small">查询</el-button>
              <el-button type="info" @click="resetSearch" plain size="small">刷新</el-button>
            </div>
          </div>
<!--        </div>-->
      </el-container>
      <div class="m-table">
        <el-container>
          <div>
            <el-form ref="searchForm" :model="searchForm" label-width="100px" inline size="small">
              <el-form-item label="所属地区:" v-if="userType === '1'">
                <el-select v-model="searchForm.cooperatorId" placeholder="请选择所属地区" size="small" @change="cooperatorChange">
                  <el-option v-for="item in cooperatorOpt" :key="item.value" :label="item.name" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属团队长:">
                <el-select v-model="searchForm.teamId" placeholder="请选择所团队长" size="small" @change="teamChange" v-loading="teamOptLoading" :disabled="teamDisabled">
                  <el-option v-for="item in teamOpt" :key="item.value" :label="item.name" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属业务员:">
                <el-select v-model="searchForm.salesmanId" placeholder="请选择所业务员" size="small" v-loading="salesmanOptLoading" :disabled="salesmanDisabled">
                  <el-option v-for="item in salesmanOpt" :key="item.value" :label="item.name" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
<!--              <el-form-item label="所属特派员:">-->
<!--                <el-select v-model="searchForm.specialId" placeholder="请选择所特派员" size="small">-->
<!--                  <el-option v-for="item in specialOpt" :key="item.value" :label="item.name" :value="item.value"></el-option>-->
<!--                </el-select>-->
<!--              </el-form-item>-->
              <el-form-item label="用户电话:">
                <el-input type="text" size="small" v-model="searchForm.phone" maxlength="11" placeholder="搜索用户电话" />
              </el-form-item>
              <el-form-item label="用户状态:">
                <el-select v-model="searchForm.offStatus" placeholder="请选择用户状态" size="small">
                  <el-option label="正常" value="0"></el-option>
                  <el-option label="注销" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="float: right;">
                <el-button type="primary" @click="loadListSearch()" size="small">查询</el-button>
                <el-button type="info" @click="resetSearch" plain size="small">刷新</el-button>
                <el-button type="success" @click="exportSearchData" plain size="small" style="margin-left: 20px;">导出数据</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border size="small">
          <el-table-column prop="phone" label="注册电话" align="center" width="120"></el-table-column>
          <el-table-column prop="cityName" label="所在地区"></el-table-column>
          <el-table-column prop="loginIp" label="登录IP"></el-table-column>
          <el-table-column prop="createDate" label="注册时间"></el-table-column>
          <el-table-column prop="loginDate" label="登录时间"></el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="searchForm.pageNo"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total"
          prev-text="上一页"
          next-text="下一页">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import excelUtil from '../utils/ExcelUtils'
export default {
  name: 'appUser',
  data () {
    return {
      openState: false,
      openFormState: false,
      formLoading: false,
      isLoading: true,
      isStatus: true,
      teamDisabled: true,
      salesmanDisabled: true,
      teamOptLoading: false,
      salesmanOptLoading: false,
      specialOptLoading: false,
      list: [],
      exportSearchDataList: [],
      cooperatorOpt: [],
      teamOpt: [],
      salesmanOpt: [],
      specialOpt: [],
      total: 0,
      allUser: 0,
      newUser: 0,
      dateArr: [],
      userType: '',
      searchForm: {
        phone: '',
        type: '',
        cooperatorId: '',
        teamId: '',
        salesmanId: '',
        specialId: '',
        startDate: '',
        endDate: '',
        offStatus: '0',
        pageNo: 1
      }
    }
  },
  methods: {
    useExportUtil (data) {
      const initColumn = [
        {
          title: '电话',
          dataIndex: 'phone',
          key: 'phone',
          className: 'text-monospace'
        },
        {
          title: '所属地区',
          dataIndex: 'cityName',
          key: 'cityName'
        },
        {
          title: '登录ip',
          dataIndex: 'loginIp',
          key: 'loginIp'
        },
        {
          title: '注册时间',
          dataIndex: 'createDate',
          key: 'createDate'
        },
        {
          title: '登录时间',
          dataIndex: 'loginDate',
          key: 'loginDate'
        }
      ]
      excelUtil.exportExcel(initColumn, data, '用户列表.xlsx')
    },
    resetSearch () {
      this.searchForm = {
        phone: '',
        type: '',
        cooperatorId: '',
        teamId: '',
        salesmanId: '',
        specialId: '',
        startDate: '',
        endDate: '',
        offStatus: '0',
        pageNo: 1
      }
      this.dateArr = []
      if (this.userType === '1') {
        this.teamDisabled = true
      }
      this.salesmanDisabled = true
      this.listData()
    },
    handleCurrentChange (val) {
      this.searchForm.pageNo = val
      this.listData()
    },
    // 市级下拉框选择
    cooperatorChange (e) {
      this.searchForm.teamId = ''
      this.searchForm.salesmanId = ''
      this.teamOpt = []
      this.salesmanOpt = []
      this.loadTeamOpt(e)
    },
    // 团队长下拉框选择
    teamChange (e) {
      this.searchForm.salesmanId = ''
      this.salesmanOpt = []
      this.loadSalesmanOpt(e)
    },
    // 导出当前查询条件的数据
    exportSearchData () {
      let _this = this
      if (_this.searchForm.startDate === '' || _this.searchForm.endDate === '') {
        _this.$message.error('请选择查询日期再导出数据')
        return
      }
      _this.isLoading = true
      _this.searchForm.type = this.userType
      this.$axios.post('/appUser/exportSearchDataList', _this.searchForm)
        .then((res) => {
          if (res.data !== null) {
            if (res.data.length > 0) {
              _this.useExportUtil(res.data)
            }
          }
          _this.exportSearchDataList = res.data
          _this.isLoading = false
        })
    },
    loadListSearch () {
      this.total = 0
      this.searchForm.pageNo = 1
      this.listData()
    },
    // 列表
    listData () {
      let _this = this
      _this.isLoading = true
      _this.searchForm.type = this.userType
      this.$axios.post('/appUser/list', _this.searchForm)
        .then((res) => {
          _this.list = []
          _this.list = res.data.rows
          _this.total = res.data.total
          _this.isLoading = false
        })
    },
    // 总数
    // loadTotal () {
    //   let _this = this
    //   this.$axios.post('/appUser/userTotal', {type: _this.userType, cooperatorId: _this.searchForm.cooperatorId})
    //     .then((res) => {
    //       _this.allUser = res.data.allUser
    //       _this.newUser = res.data.newUser
    //     })
    // },
    onDateChange (e) {
      let startDate = new Date(e[0])
      let endDate = new Date(e[1])
      // this.searchForm.startDate = startDate
      // this.searchForm.endDate = endDate
      this.searchForm.startDate = startDate.getFullYear() +
        '-' + (startDate.getMonth() < 10 ? '0' + (startDate.getMonth() + 1) : (startDate.getMonth() + 1)) +
        '-' + (startDate.getDate() < 10 ? '0' + startDate.getDate() : startDate.getDate())
      this.searchForm.endDate = endDate.getFullYear() +
        '-' + (endDate.getMonth() < 10 ? '0' + (endDate.getMonth() + 1) : (endDate.getMonth() + 1)) +
        '-' + (endDate.getDate() < 10 ? '0' + endDate.getDate() : endDate.getDate())
    },
    // 城市合作商下拉选项
    loadCooperatorOpt () {
      let _this = this
      this.$axios.post('/options/cooperatorOpt')
        .then((res) => {
          _this.cooperatorOpt = res.data
        })
    },
    // 团队长下拉选项
    loadTeamOpt (cooperatorId) {
      let _this = this
      _this.teamOptLoading = true
      _this.teamOpt = []
      this.$axios.post('/options/teamOpt', {userType: _this.userType, cooperatorId: cooperatorId})
        .then((res) => {
          _this.teamOpt = res.data
          _this.teamDisabled = false
          _this.teamOptLoading = false
        })
    },
    // 业务员下拉选项
    loadSalesmanOpt (teamId) {
      let _this = this
      _this.salesmanOptLoading = true
      _this.salesmanOpt = []
      this.$axios.post('/options/salesmanOpt', {teamId: teamId})
        .then((res) => {
          _this.salesmanOpt = res.data
          _this.salesmanDisabled = false
          _this.salesmanOptLoading = false
        })
    }
    // 特派员下拉选项
    // loadSpecialOpt () {
    //   let _this = this
    //   _this.specialOptLoading = true
    //   _this.specialOpt = []
    //   let url = _this.userType === '1' ? '/options/specialOpt' : '/options/cityBySpecialOpt'
    //   this.$axios.post(url)
    //     .then((res) => {
    //       _this.specialOpt = res.data
    //       _this.specialOptLoading = false
    //     })
    // }
  },
  mounted () {
    if (!window.sessionStorage.user) {
      this.$router.push({name: 'login'})
    } else {
      this.userType = JSON.parse(window.sessionStorage.user).userType
    }
    this.listData()
    // this.loadTotal()
    // 如果是省级合作商则加载省内城市合作商列表，否则直接加载团队长列表
    if (this.userType === '1') {
      this.loadCooperatorOpt()
    } else {
      this.loadTeamOpt()
    }
    // this.loadSpecialOpt()
  }
}
</script>

<style scoped>
.m-user-open-item label {
  width: 100px;
  text-align: right;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/appUser/AppUser.vue